import { useIsScreenSizeSmall } from "@trueskin-web/theme"

import PlanImage from "./plan-image"
import PlanVariant from "./plan-variant"
import RecommendedLabel from "./recommended-label"
import SubscriptionBenefitsList from "./subscription-benefits-list"

const SubscriptionVariant = ({ variant, isSelected, onClick }) => {
  const isMobile = useIsScreenSizeSmall()
  const isCHLocale = variant.locale === "de-CH"
  const isCollapsedPreviewEnabled =
    variant.subscriptionBenefits.length > 0 &&
    (isCHLocale || variant.instalments === 2)

  const CollapsedPreview = isCollapsedPreviewEnabled ? (
    <SubscriptionBenefitsList benefits={variant.subscriptionBenefits} />
  ) : null

  const PriceTitle = (
    <>
      <span
        data-testid="web-portal-plan-selection-plan-full-price"
        sx={{
          marginRight: 1,
          fontSize: 2,
          color: "disabled",
          textDecoration: "line-through",
        }}
      >
        {variant.priceWithoutDiscounts}
      </span>
      <span
        data-testid="web-portal-plan-selection-plan-discounted-price"
        sx={{ fontSize: 3, fontWeight: "bold" }}
      >
        {variant.priceTitle}
      </span>
      <span sx={{ fontSize: 0 }}>/Monat</span>
    </>
  )

  const LabelTile = variant.isRecommended ? (
    <RecommendedLabel sx={{ display: [null, "none"] }} />
  ) : null

  return (
    <PlanVariant
      isSelected={isSelected}
      title={variant.title}
      collapsedByDefault={!isMobile}
      onClick={onClick}
      collapsedPreview={CollapsedPreview}
      priceTitle={PriceTitle}
      labelTile={LabelTile}
      sx={{
        border: isSelected ? "2px solid" : "1px solid",
        borderColor: isSelected ? "darkBlue" : "grey",
        p: 4,
        mb: [null, 4],
        mt: [4, 0],
      }}
    >
      <PlanImage image={variant.image} title={variant.title} />
      <SubscriptionBenefitsList benefits={variant.subscriptionBenefits} />
    </PlanVariant>
  )
}

export default SubscriptionVariant
